import React from "react";
import styled from "styled-components";
import { breakpoints } from '../../styled-components/constants';

const DayWrap = styled.div`
  text-align: ${props => props.isNav ? 'right' : 'center'};
  @media (min-width: ${breakpoints.desktop}) {
    text-align: center;
  }
`;

export default DayWrap;



// WEBPACK FOOTER //
// ./src/components/CountdownElement/DayWrap.js